import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SchedulerService {

    private tasks: {[key: string]: (() => Promise<void>)[]} = {};
    private tasksRunning: {[key: string]: boolean} = {};

    constructor() { }

    addTask(task: Task) {
        if (!this.tasks[task.taskType]) this.tasks[task.taskType] = [];
        this.tasks[task.taskType].push(task.task);
        this.runTasks(task.taskType);
    }

    addTasks(tasks: Tasks) {
        if (!this.tasks[tasks.taskType]) this.tasks[tasks.taskType] = [];
        this.tasks[tasks.taskType].push(...tasks.tasks);
        this.runTasks(tasks.taskType);
    }

    private async runTasks(taskType: string){
        if(this.tasksRunning[taskType]) return;
        while (this.tasks[taskType].length > 0) {
            this.tasksRunning[taskType] = true;
            try {
                await this.tasks[taskType][0]();
            } catch(e) {
                console.error(`[Scheduler Service runTask] error. Task type: ${taskType}. Error: ${e}`);
            } finally {
                this.tasks[taskType].splice(0, 1);
            }
        }
        this.tasksRunning[taskType]= false;
    }
}

export interface Task {
  taskType: string;
  task: () => Promise<void>;
}

export interface Tasks {
  taskType: string;
  tasks: (() => Promise<void>)[];
}
